import Icon from '../components/Icon.vue'

Icon.register({
  dna: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0.1 494.1C-1 503.6 6.4 511.9 16 511.9L48.3 512C56.4 512 63.2 506.1 64.3 498.1 65 493.2 66.1 487 67.7 480H380C381.6 486.9 382.9 493.2 383.5 498.1 384.6 506.1 391.4 512.1 399.5 512L431.8 511.9C441.4 511.9 448.9 503.6 447.7 494.1 443.1 456.2 422.1 365.1 328.8 286.4 311.2 298.8 291.7 310.6 270.3 321.8 276.5 326.4 281.7 331.2 287.3 336H159.7C181 317.9 206.7 300.4 238.4 284.6 410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6 0.1 432 0.1L399.6 0C391.5 0 384.7 5.9 383.6 13.9 382.9 18.8 381.8 25 380.2 32H67.8C66.2 25 65.1 18.9 64.4 13.9 63.3 5.9 56.5-0.1 48.4 0L16.1 0.1C6.5 0.1-1 8.4 0.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2 0.1 494.1zM224 219.6C198.9 205.9 177.6 191.2 159.7 176H288.2C270.4 191.2 249.1 206 224 219.6zM355.1 96C349.3 106.4 342.3 117.1 334.1 128H114C105.7 117.1 98.7 106.4 93 96H355.1zM92.9 416C98.7 405.6 105.7 394.9 113.9 384H333.3C341.6 394.9 348.7 405.6 354.5 416H92.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dna.js
// module id = MvXe
// module chunks = 144